module.exports = __webpack_public_path__ + "img/background3.3f2c2821.png";